import type {CredentialsConfig} from 'src/types/data-integration';
import type {CredentialsActions} from 'src/action-creators/data-integration';

import {
  GET_CREDENTIALS_META,
  GET_CREDENTIALS,
} from 'src/action-creators/data-integration';


type State = {
  credentials: null | CredentialsConfig;
  credentialsMetaData: null | CredentialsConfig;
};

const initialState = {
  credentials: null,
  credentialsMetaData: null,
} as const;

export default (
  state: State = initialState,
  action: CredentialsActions,
): State => {
  switch (action.type) {
    case GET_CREDENTIALS_META:
      return {
        ...state,
        credentialsMetaData: action.payload,
      };
    case GET_CREDENTIALS:
      return {
        ...state,
        credentials: action.payload,
      };
  }
  return state;
};
